import { render } from "./BreadcrumbComponent.vue?vue&type=template&id=3fcaee72&scoped=true"
import script from "./BreadcrumbComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbComponent.vue?vue&type=script&lang=js"

import "./BreadcrumbComponent.vue?vue&type=style&index=0&id=3fcaee72&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcaee72"]])

export default __exports__